import { render } from "./WebTop.vue?vue&type=template&id=af9ce222"
import script from "./WebTop.vue?vue&type=script&lang=js"
export * from "./WebTop.vue?vue&type=script&lang=js"

import "./WebTop.vue?vue&type=style&index=0&id=af9ce222&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__